
import bugsnagClient from 'JS/global/bugsnag';
import SavedVehicleCard from '../../shared/components/SavedVehicleCard.vue';
import Spinner from 'JS/components/Spinner.vue';
import TireRecommendationSidebar from './TireRecommendationSidebar.vue';
import UiButton from 'JS/components/UiButton.vue';
import VehicleEditorSidebar from './VehicleEditorSidebar.vue';
import Vue from 'vue';
import { Component, Inject } from 'vue-property-decorator';
import { ICustomerVehicle, IUpdateVehicleRequest } from 'JS/types/Automotive';
import { ICustomerVehicleService } from 'JS/services/automotive/CustomerVehicleService';

@Component({
	name: 'TireFitmentVehicles',
	components: {
		UiButton,
		SavedVehicleCard,
		Spinner,
		TireRecommendationSidebar,
		VehicleEditorSidebar,
	}
})
class TireFitmentVehicles extends Vue {

	@Inject('CustomerVehicleService')
	_vehicleService: ICustomerVehicleService;

	/* Data
	============================================*/

	savedVehicles: ICustomerVehicle[] = [];
	selectedVehicle: ICustomerVehicle | null = null;
	vehicleBeingEdited: ICustomerVehicle | null = null;
	showSpinner: boolean = true;
	showRecommendationSidebar: boolean = false;
	vehicleLookupLoading: boolean = true;

	/* Methods
	============================================*/

	addVehicle() {
		this.selectedVehicle = null;
		this.vehicleLookupLoading = false;
		this.showRecommendationSidebar = true;
	}

	async getVehicles() {
		try {
			this.showSpinner = true;
			this.savedVehicles = await this._vehicleService.getVehicles();
		} catch (e) {
			bugsnagClient.notify(e, {
				metaData: {
					info: "Failed to load customer vehicles"
				}
			});
		} finally {
			this.showSpinner = false;
		}
	}

	async removeVehicle(vehicle: ICustomerVehicle) {
		try {
			this.showSpinner = true;
			await this._vehicleService.removeVehicle(vehicle.id);
			await this.getVehicles();
			this.cancelEditingVehicle();
		} catch (e) {
			bugsnagClient.notify(e, {
				metaData: {
					info: "Failed to remove customer vehicles"
				}
			});
		} finally {
			this.showSpinner = false;
		}
	}

	selectVehicle(vehicle: ICustomerVehicle) {
		this._vehicleService.setPrimaryVehicle(vehicle);
		this.selectedVehicle = vehicle;
		this.showRecommendationSidebar = true;
	}

	editVehicle(vehicle: ICustomerVehicle) {
		this.vehicleBeingEdited = vehicle;
	}

	cancelEditingVehicle() {
		this.vehicleBeingEdited = null;
	}

	async saveEditedVehicle(req: IUpdateVehicleRequest) {
		try {
			this.showSpinner = true;
			await this._vehicleService.updateVehicle(req);
			await this.getVehicles();
			this.cancelEditingVehicle();
		} catch (e) {
			bugsnagClient.notify(e, {
				metaData: {
					info: "Failed to save customer vehicle"
				}
			});
		} finally {
			this.showSpinner = false;
		}
	}

	/* Lifecycle Hooks
	============================================*/

	created() {
		this.getVehicles();
	}

}

export default TireFitmentVehicles;
